<template>
  <ipo3-page>
    <template slot="title">分類管理</template>
    <template slot="tools">
            <el-input v-model="form.title" style="width:200px;margin-right:10px;" placeholder="請輸入標題"></el-input>
      <el-button icon="el-icon-edit" @click="onSearch" type="primary">搜索</el-button>
      <el-button icon="el-icon-edit" @click="onCreate" type="primary">添加分類</el-button>
    </template>
    <template slot="page">
      <div class="page_view">
        <el-table
          ref="tableArr"
          v-loading="isLoading"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChange"
          :header-cell-style="getRowClass"
        >
          <template v-for="item in items">
            <el-table-column
              :key="item.name"
              header-align="center"
              align="center"
              :label="item.name"
              :prop="item.id"
            ></el-table-column>
          </template>
          <el-table-column
            header-align="center"
            align="center"
            label="操作"
            class="operate"
            width="160"
          >
            <template scope="scope">
              <div>
                <el-button @click="onHandle(scope.$index, scope.row)" size="mini" type="success">編輯</el-button>
                 <el-button
                  @click="onDelete(scope.$index, scope.row)"
                  size="mini"
                  type="danger"
                >{{$t('btns.del')}}</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10,20,30,40,100]"
          :page-size="paginate"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagecount"
        ></el-pagination>
      </div>
      <category-dialog ref="categoryDialog" @sucess="onSucess"></category-dialog>
    </template>
  </ipo3-page>
</template>
<script>
import categoryDialog from "./views/category_dialog";
export default {
  name: "news-tags",
  components: { categoryDialog },
  data() {
    return {
      tableData: [],
      isLoading: false,
      getRowClass: {
        background: "#F2F2F2"
      },
      form:{
        title:''
      },
      items: [
        { name: "編號", id: "id" },
        { name: "名稱", id: "name" },
        { name: "排序", id: "sort" },
        // { name: "狀態", id: "status_text" }
      ],
      currentPage: 1,
      pagecount: 1,
      paginate: 10
    };
  },
  created() {
    this.getTags();
  },
  methods: {
    onSucess() {
      this.getTags();
    },
    onCreate() {
      this.$refs.categoryDialog.show();
    },
    onHandle(index, value) {
      this.$refs.categoryDialog.show(value);
    },
    onDelete(index,value)
    {
      var self = this;
      this.$http.post('/admin/category/delete',{id:value.id}).then(res=>{
          if(res.code==200)
          {
            self.getTags();
            self.$message.success("删除成功");
          }else
          {
            self.$message.error(res.msg);
          }
      });
    },
     onSearch()
    {
      let params = Object.assign({},this.form);
      
      this.getTags(params);
    },
    getTags(value={}) {
      var self = this;
      this.$http
        .get("/admin/category", { size: this.paginate, page: this.currentPage,...value})
        .then(res => {
          console.log("res:", res);
          let { data, total, per_page } = res.data;
          self.pagecount = total;
          self.tableData = data;
        });
    },
    handleSizeChange(value) {
      this.paginate = value;
      this.getTags();
    },
    handleCurrentChange(value) {
      this.currentPage = value;
      this.getTags();
    }
  }
};
</script>